import React, { useEffect, useState } from "react";
import "./Popup.scss";
import CloseCrossICON from "../../assets/images/closeCross.svg";
import Draggable from "react-draggable";

const Popup = (props) => {
  const [state, setState] = useState({
    activeDrags: 0,
    deltaPosition: {
      x: 0,
      y: 0,
    },
    controlledPosition: {
      x: 0,
      y: 0,
    },
  });

  useEffect(() => {
    // Use a Map to store removed classes with elements as keys
    let removedClassesMap = new Map();

    function removeDragHandleClasses() {
      const elements = document.querySelectorAll('[class*="dragHandle"]');
      elements.forEach((element) => {
        // Store removed classes for this element
        const removedClasses = [];
        element.classList.forEach((className) => {
          if (className.includes("dragHandle")) {
            removedClasses.push(className);
            element.classList.remove(className);
          }
        });
        // Store the removed classes in the map
        if (removedClasses.length > 0) {
          removedClassesMap.set(element, removedClasses);
        }
      });
    }

    function restoreDragHandleClasses() {
      removedClassesMap.forEach((removedClasses, element) => {
        removedClasses.forEach((className) => {
          element.classList.add(className);
        });
      });
      // Clear the map after restoring
      removedClassesMap.clear();
    }

    // Remove drag handle classes on mount
    removeDragHandleClasses();

    // Restore drag handle classes on cleanup
    return () => {
      restoreDragHandleClasses();
    };
  });

  const handleDrag = (e, ui) => {
    const { x, y } = state.deltaPosition;
    setState({
      deltaPosition: {
        x: x + ui.deltaX,
        y: y + ui.deltaY,
      },
    });
  };

  const onStart = () => {
    setState({ activeDrags: state.activeDrags + 1 });
  };

  const onStop = () => {
    setState({ activeDrags: state.activeDrags - 1 });
  };

  const dragHandlers = { onStart: onStart, onStop: onStop };

  return (
    <div className="modalGlobal" id={props.parentID ? props.parentID : " "}>
      <div
        className="overlay"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          props.close();
        }}
      ></div>
      <Draggable
        handle=".header"
        {...dragHandlers}
        defaultPosition={{ x: 0, y: 100 }}
      >
        <div className="modalContent" style={{ width: props.width + "px" }}>
          <div className="header">
            {props.header}
            <img onClick={props.close} src={CloseCrossICON} alt="Close" />
          </div>
          <div onScroll={props.onScroll} ref={props.ref} className="modalBody">
            {props.children}
          </div>
          {props.htmlFooterButtons &&
              <div 
              id="html-footerButtons"
              style={{ display: "flex", justifyContent: "flex-end", gap: "20px", marginBottom: "5px", marginRight: "10px" }}>
                <span
                  style={{
                    display: "flex",
                    marginTop: "20px",
                    cursor: "pointer",
                  }}
                  id="html-cancelButton"
                  onClick={props.onCancel}
                >
                  Cancel
                </span>
                <button
                  id="html-saveButton"
                  className="overrideButton"
                  onClick={props.onSave || props.close}
                >
                  Save
                </button> 
              </div>
            }
          {props.save || props.cancel ? (
            <div className="footerBtns">
              <button
                onClick={props.save}
                className={
                  props.disableButton === null
                    ? "save"
                    : props.disableButton
                      ? "cancel"
                      : "save"
                }
                disabled={props.disableButton ? props.disableButton : false}
              >
                {props.btnLabel ? props.btnLabel : "Save"}
              </button>
              <button onClick={props.close} className="cancel">
                Cancel
              </button>
            </div>
          ) : null}
          {props.animatedButton ? <>{props.animatedButton}</> : null}
          <div className="clearfix"></div>
        </div>
      </Draggable>
    </div >
  );
};

export default Popup;
